import React from "react";
import "./Home.css";
import { SubmissionButton } from "../SumbissionButton";
import { Profile } from "../Profile";

export const TutorialCalls = () => {
  const submitButton = {
    title: "Tutorial Proposal",
    url: "https://advance-crt.ie",
  };

  const profilesTutorial = [
    {
      title: "Dr",
      firstName: "Fabrizio",
      surname: "De Vita",
      university: "University of Messina, Italy",
      bio: "https://archivio.unime.it/it/dipartimenti/ingegneria/de-vita-fabrizio",
      image: "./images/profiles/fabrizio.jpg",
      linkedin: null,
      twitter: null,
      email: "fabrizio.devita@unime.it",
    },
    {
      title: "Dr",
      firstName: "Aisling",
      surname: "O'Driscoll",
      university: "University College Cork",
      bio: "https://www.ucc.ie/en/compsci/people/odriscolldraisling/",
      image: "./images/profiles/AislingO.png",
      linkedin:
        "https://www.linkedin.com/in/aislingodriscoll/?originalSubdomain=ie",
      email: "aisling.odriscoll@ucc.ie",
    },
  ];

  return (
    <div className="page-layout">
      <div className="text-layout">
        <h2>Call for Tutorials</h2>
        <p>
          SMARTCOMP is the premier forum for exploring cutting-edge research,
          innovation, and applications in the rapidly evolving domain of smart
          computing, encompassing advancements in sensor-based technologies,
          IoT, cyber-physical systems, edge and cloud computing, big data,
          machine learning, and AI.
        </p>
        <p>
          The IEEE SMARTCOMP 2025 organizers invite proposals for tutorials. We
          will consider tutorials on any topic if highly relevant for the
          SMARTCOMP community. Tutorials should be of interest for a substantial
          part of the SMARTCOMP audience and represent a sufficiently mature
          area of research or a particular emerging topic. Topics can include
          pervasive/ubiquitous computing, edge/cloud computing, software defined
          networking, sensor networks, decision making under uncertainty, IoT,
          AI/deep learning, security and privacy, cyber- physical systems and
          their application, social computing, cognitive computing, and
          validation within smart computing environments (smart buildings,
          cities, grids, healthcare, transport, precision agriculture and other
          innovations contributing to smart living).
        </p>
        <h3>Submission Guidelines</h3>
        <p>The tutorial proposals should include:</p>
        <ul>
          <li>Title of the tutorial;</li>
          <li>Short biography of the organizer(s);</li>
          <li>
            An extended abstract describing objectives, motivation and
            references of the tutorial. This will be included in the conference
            proceedings in case of acceptance.
          </li>
          <li>Timeliness, duration (e.g., 1.5h; 3h) and estimated audience.</li>
          <li>
            An outline of the tutorial content, including its tentative
            schedule.
          </li>
          <li>
            Pre-required environment (e.g., Virtual machine, PC characteristics,
            AWS account, etc. if necessary)
          </li>
          <li>
            If appropriate, a description of the past/relevant experience of the
            speaker(s) on the topic of the tutorial.
          </li>
        </ul>
        <p>
          In the previous year, tutorials were organized on the 2nd day of the
          conference.
        </p>
        <p>
          Proposals should be submitted, no later than April 16, 2025, in PDF
          format by email to{" "}
          <a href="mailto:aisling.odriscoll@ucc.ie">aisling.odriscoll@ucc.ie</a>{" "}
          and <a href="mailto: fdevita@unime.it">fdevita@unime.it</a> with the
          subject line “SMARTCOMP 2025 Tutorial Proposal”.
        </p>
        <p>
          Proposals will be evaluated based on the relevance for the SMARTCOMP
          community, quality of the proposal and expertise of the presenters. If
          accepted, the tutorial organizers could provide tutorial materials
          that will be made available on a dedicated section of the main
          conference website. A call for participation will be disseminated by
          publicity chairs
        </p>

        <h3>Important Dates</h3>
        <p>
          Paper submission:{" "}
          <span style={{ fontWeight: "bold" }}> 16 April 2025</span>
        </p>
        <p>
          Acceptance notification:{" "}
          <span style={{ fontWeight: "bold" }}> 2 May 2025</span>
        </p>
        <p>
          Tutorial Day: <span style={{ fontWeight: "bold" }}> TBA </span>
        </p>

        <h3>Tutorial Co-Chairs</h3>
        <div>
          {profilesTutorial.map(function (data) {
            return <Profile props={data} />;
          })}
        </div>
      </div>
    </div>
  );
};
